import { createContext, useContext } from 'react';

export interface VulnerabilityContextProps {
  getResourceVulnerabilities();
  getPackageVulnerabilities();
  getCVEVulnerabilities();
  isPatchable: Record<string, any>;
  packageType: Record<string, any>;
  packageName: Record<string, any>;
  severity: Record<string, any>;
  severities: Record<string, any>[];
  isExpanded?: boolean;
  isExploitable: Record<string, any>;
  isInternetExposed: Record<string, any>;
  updateValue(field, value);
}

export const VulnerabilityContext = createContext<VulnerabilityContextProps>({
  getResourceVulnerabilities: () => {},
  getPackageVulnerabilities: () => {},
  getCVEVulnerabilities: () => {},
  packageType: {},
  isPatchable: {},
  packageName: {},
  severity: {},
  severities: [],
  isExpanded: false,
  isExploitable: {},
  isInternetExposed: {},
  updateValue: () => {},
});

export const VulnerabilityContextProvider = VulnerabilityContext.Provider;

export const useVulnerabilityContext = () => useContext(VulnerabilityContext);
